import { combineReducers } from "redux";

import aktorerReducer from "./aktorerReducer";
import arkivsakReducer from "./arkivsakReducer";
import bybetjenterReducer from "./bybetjenterReducer";
import bybetjenterGrupperReducer from "./bybetjentGrupperReducer";
import bybetjenterRollerReducer from "./bybetjentRollerReducer";
import bybetjenterSeksjonerReducer from "./bybetjentSeksjonerReducer";
import byBetjentTeamHistorikkReducer from "./byBetjentTeamHistorikkReducer";
import elsparksykkelGebyrReducer from "./elsparksykkelGebyrReducer";
import ettersendelserReducer from "./ettersendelserReducer";
import ettersendelserTilGodkjenningReducer from "./ettersendelserTilGodkjenningReducer";
import fargerReducer from "./fargerReducer";
import flashMessagesReducer from "./flashMessagesReducer";
import folgebrevReducer from "./folgebrevReducer";
import formReducers from "./forms/formReducers";
import ileggelseBilderReducer from "./ileggelseBilderReducer";
import ileggelseEttersendelserReducer from "./ileggelseEttersendelserReducer";
import ileggelseHistorikkReducer from "./ileggelseHistorikkReducer";
import ileggelseKlagerReducer from "./ileggelseKlagerReducer";
import ileggelseKommentarReducer from "./ileggelseKommentarReducer";
import ileggelseleveringstyperReducer from "./ileggelseleveringstyperReducer";
import ileggelseMakuleringerReducer from "./ileggelseMakuleringerReducer";
import ileggelseReducer from "./ileggelseReducer";
import ileggelseRettelserReducer from "./ileggelseRettelserReducer";
import ileggelserReducer from "./ileggelserReducer";
import ileggelsestyperReducer from "./ileggelsestyperReducer";
import innkrevingReducer from "./innkrevingReducer";
import innsynMotorvognReducer from "./innsynMotorvognReducer";
import internkoderIleggelserReducer from "./internkoderIleggelserReducer";
import internkoderMiljogebyrReducer from "./internkoderMiljogebyrReducer";
import kjoretoyMerkerReducer from "./kjoretoyMerkerReducer";
import kjoretoyTyperReducer from "./kjoretoyTyperReducer";
import klageDetailReducer from "./klageDetailReducer";
import klageIleggelseImageReducer from "./klageIleggelseimageReducers";
import klageIleggelseLightboxImageReducer from "./klageIleggelseLightboxImageReducer";
import klageIleggelseReducer from "./klageIleggelseReducer";
import klageIleggelserReducer from "./klageIleggelserReducer";
import klageIleggelseThumbnailImageReducer from "./klageIleggelseThumbnailImageReducer";
import klageKoderReducer from "./klageKoderReducer";
import klageMiljoKontrollImageReducer from "./klageMiljoKontrollImageReducer";
import klageMiljoKontrollLightboxImageReducer from "./klageMiljoKontrollLightboxImageReducer";
import klageMiljoKontrollThumbnailImageReducer from "./klageMiljoKontrollThumbnailImageReducer";
import klageRapportReducer from "./klageRapportReducer";
import kalgeRapportSaksbehandlerReducer from "./klageRapportSaksbehandlerReducer";
import miljogebyrBilderReducer from "./miljogebyrBilderReducer";
import miljogebyrerReducer from "./miljogebyrerReducer";
import miljogebyrEttersendelserReducer from "./miljogebyrEttersendelserReducer";
import miljogebyrHistorikkReducer from "./miljogebyrHistorikkReducer";
import miljogebyrKlagebehandlingVedtakReducer from "./miljogebyrKlagebehandelingVedtakReducer";
import miljogebyrKlagerReducer from "./miljogebyrKlagerReducer";
import miljogebyrKommentarReducer from "./miljogebyrKommentarReducer";
import miljogebyrReducer from "./miljogebyrReducer";
import miljogebyrTilBehandlingReducer from "./miljogebyrTilBehandlingReducer";
import miljokontrollerReducer from "./miljokontrollerReducer";
import miljokontrollHistorikkReducer from "./miljokontrollHistorikkReducer";
import miljokontrollKommentarerReducer from "./miljokontrollKommentarerReducer";
import miljokontrollReducer from "./miljokontrollReducer";
import miljoleveringstyperReducer from "./miljoleveringstyperReducer";
import miljoMakuleringerReducer from "./miljoMakuleringerReducer";
import miljoRettelserReducer from "./miljoRettelserReducer";
import mottakertyperReducer from "./mottakertyperReducer";
import nasjonerReducer from "./nasjonerReducer";
import overtredelsegrupperReducer from "./overtredelsegrupperReducer";
import overtredelseskoderIleggelserReducer from "./overtredelseskoderIleggelserReducer";
import overtredelseskoderMiljogebyrReducer from "./overtredelseskoderMiljogebyrReducer";
import piggdekkontrollerReducer from "./piggdekkontrollerReducer";
import rapportReducers from "./rapporter/rapportReducers";
import rettekoderReducer from "./rettekoderReducer";
import skiftloggerReducer from "./skiftloggerReducer";
import submittedFormReducers from "./submittedForms/submittedFormReducers";
import uferdigstilteKlagesakerReducer from "./uferdigstilteKlagesakerReducer";
import uregistrertekontrollerReducer from "./uregistrertekontrollerReducer";
import vedtakerReducer from "./vedtakerReducer";
import vedtakskoderReducer from "./vedtakskoderReducer";
import ventilstillingerBilderReducer from "./ventilstillingerBilderReducer";
import ventilstillingerReducer from "./ventilstillingerReducer";
import ventilstillingReducer from "./ventilstillingReducer";

import createAdvancedListReducer from "./createAdvancedListReducer";
import ileggelseKlagebehandlingVedtakReducer from "./ileggelseKlagebehandelingVedtakReducer";
import innsynPersonopplysningerReducer from "./innsynPersonopplysningerReducer";
import miljoKontrollerBilderReducer from "./miljokontrollBilderReducer";
import miljoKontrollerLightboxBilderReducer from "./miljokontrollLightboxBilderReducer";
import miljoKontrollerThumbnailBilderReducer from "./miljokontrollThumbnailBilderReducer";

const rootReducer = combineReducers({
  aktorer: aktorerReducer,
  bybetjenter: bybetjenterReducer,
  betjentgrupper: bybetjenterGrupperReducer,
  betjentTeamHistorikk: byBetjentTeamHistorikkReducer,
  betjentroller: bybetjenterRollerReducer,
  bybetjenterseksjoner: bybetjenterSeksjonerReducer,
  farger: fargerReducer,
  folgebrev: folgebrevReducer,
  skiftlogger: skiftloggerReducer,
  ventilstillinger: ventilstillingerReducer,
  ventilstillingerBilder: ventilstillingerBilderReducer,
  ventilstilling: ventilstillingReducer,
  innsynMotorvogn: innsynMotorvognReducer,
  klageIleggelse: klageIleggelseReducer,
  klageIleggelser: klageIleggelserReducer,
  klageIleggelseImage: klageIleggelseImageReducer,
  klageIleggelseLightboxImage: klageIleggelseLightboxImageReducer,
  klageIleggelseThumbnailImage: klageIleggelseThumbnailImageReducer,
  klageMiljoKontrollImage: klageMiljoKontrollImageReducer,
  klageMiljoKontrollLightboxImage: klageMiljoKontrollLightboxImageReducer,
  klageMiljoKontrollThumbnailImage: klageMiljoKontrollThumbnailImageReducer,
  klageDetail: klageDetailReducer,
  forms: formReducers,
  flashMessages: flashMessagesReducer,
  elsparksykkelGebyr: createAdvancedListReducer(
    "ELSPARKSYKKELGEBYR",
    elsparksykkelGebyrReducer,
  ),
  ettersendelser: createAdvancedListReducer(
    "ETTERSENDELSER",
    ettersendelserReducer,
  ),
  ettersendelserTilGodkjenning: createAdvancedListReducer(
    "ETTERSENDELSERTILGODKJENNING",
    ettersendelserTilGodkjenningReducer,
  ),
  ileggelse: ileggelseReducer,
  ileggelseBilder: ileggelseBilderReducer,
  ileggelser: createAdvancedListReducer("ILEGGELSER", ileggelserReducer),
  ileggelseHistorikk: ileggelseHistorikkReducer,
  ileggelseRettelser: ileggelseRettelserReducer,
  ileggelseMakuleringer: ileggelseMakuleringerReducer,
  ileggelseKlager: ileggelseKlagerReducer,
  ileggelseKlagebehandlingVedtak: ileggelseKlagebehandlingVedtakReducer,
  ileggelsestyper: ileggelsestyperReducer,
  innkreving: innkrevingReducer,
  internkoderIleggelser: internkoderIleggelserReducer,
  internkoderMiljogebyr: internkoderMiljogebyrReducer,
  ileggelseleveringstyper: ileggelseleveringstyperReducer,
  innsynPersonopplysninger: innsynPersonopplysningerReducer,
  overtredelseskoderIleggelser: overtredelseskoderIleggelserReducer,
  overtredelsegrupper: overtredelsegrupperReducer,
  overtredelseskoderMiljogebyr: overtredelseskoderMiljogebyrReducer,
  kjoretoyTyper: kjoretoyTyperReducer,
  kjoretoyMerker: kjoretoyMerkerReducer,
  miljogebyrer: createAdvancedListReducer("MILJOGEBYRER", miljogebyrerReducer),
  miljogebyrTilBehandling: createAdvancedListReducer(
    "MILJOGEBYRTILBEHANDLING",
    miljogebyrTilBehandlingReducer,
  ),
  miljogebyr: miljogebyrReducer,
  miljogebyrBilder: miljogebyrBilderReducer,
  miljogebyrEttersendelser: miljogebyrEttersendelserReducer,
  miljogebyrHistorikk: miljogebyrHistorikkReducer,
  miljogebyrKlager: miljogebyrKlagerReducer,
  miljogebyrKlagebehandlingVedtak: miljogebyrKlagebehandlingVedtakReducer,
  miljoRettelser: miljoRettelserReducer,
  miljoMakuleringer: miljoMakuleringerReducer,

  miljokontroller: miljokontrollerReducer,
  miljokontroll: miljokontrollReducer,
  miljokontrollerBilder: miljoKontrollerBilderReducer,
  miljokontrollHistorikk: miljokontrollHistorikkReducer,
  miljokontrollerLightboxBilder: miljoKontrollerLightboxBilderReducer,
  miljokontrollerThumbnailBilder: miljoKontrollerThumbnailBilderReducer,
  miljokontrollKommentarer: miljokontrollKommentarerReducer,
  uregistrertekontroller: createAdvancedListReducer(
    "UREGISTRERTEKONTROLLER",
    uregistrertekontrollerReducer,
  ),
  nasjoner: nasjonerReducer,
  vedtakskoder: vedtakskoderReducer,
  vedtaker: vedtakerReducer,
  klagekoder: klageKoderReducer,
  piggdekkontroller: createAdvancedListReducer(
    "PIGGDEKKONTROLLER",
    piggdekkontrollerReducer,
  ),
  ileggelseEttersendelser: ileggelseEttersendelserReducer,
  miljoleveringstyper: miljoleveringstyperReducer,
  mottakertyper: mottakertyperReducer,
  sak: arkivsakReducer,
  ileggelseKommentarer: ileggelseKommentarReducer,
  miljoKommentarer: miljogebyrKommentarReducer,
  klagerapport: klageRapportReducer,
  kalgeRapportSaksbehandler: kalgeRapportSaksbehandlerReducer,
  rapporter: rapportReducers,
  rettekoder: rettekoderReducer,
  uferdigstilteKlagesaker: createAdvancedListReducer(
    "UFERDIGSTILTEKLAGESAKER",
    uferdigstilteKlagesakerReducer,
  ),
  submittedForms: submittedFormReducers,
});

export default rootReducer;
